import { render, staticRenderFns } from "./SettingsListItemsPanel.vue?vue&type=template&id=daee562c"
import script from "./SettingsListItemsPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsListItemsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports